
import React, { useEffect, useState } from 'react'
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import CustomerServices from '../../services/CustomerServices';
import { pascalCASE } from '../../utils/convertDate';

import { formatDate } from './../../utils/convertDate';


export default function NewtoBank() {
    const [customer, setCustomer] = useState([])

    const listCustomer = async () => {
        const customers = await CustomerServices.getSummary();
        setCustomer([...customers.data.newToBankCustomers]);
    }

    const exportCSV = async () => {
        const resp = await CustomerServices.exportNewToBank();
        window.open(resp.data)
    };


    useEffect(() => {
        listCustomer();
    }, [])

    return (<>
        <Layout title="New to Bank" pageTag={'customer'} current={'/new-to-bank'} curentPage={'new-customer'}  >
            <React.Fragment>
                <main>
                    <div className='max-w-7xl '>

                        <div className=" flex justify-end">

                            <button
                                type="button"
                                onClick={exportCSV}
                                className="hover:text-white mt-5 active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                        </div>
                        {customer.length === 0 ? (
                            <div className=" mt-8"> No data available for these dates to show. </div>
                        ) : 
                        <>
                        <div className="">

                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">

                                            <table className="min-w-full table-fixed divide-y divide-gray-300 mb-32">
                                                <thead>
                                                    <tr>

                                                        <th scope="col" className="min-w-[8rem] pl-4 py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Username
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Account Name
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Account Class
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            BVN
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Email Address
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Phone number
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Account Number
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Location
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Marital Status
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Is-minor
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem] pr-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Nationality
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Email address
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Date  Opened
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            IsPnd
                                                        </th>

                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">

                                                        </th>

                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {customer.map((person, i) => (
                                                        <tr key={i} className="bg-gray-50">
                                                            <td className="whitespace-nowrap pl-4  py-4 pr-3 text-sm font-medium text-indigo-600">{person.userName == null ? "N/A" : person.userName}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.surname} {pascalCASE(person.firstName)}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.accountClass}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.bvn}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.email}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.phoneNumber}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.accountNumber}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.location}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.maritalStatus}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.minor}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.nationalityCode}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500"> {formatDate(person.dateCreated)}</td>
                                                            <td className="whitespace-nowrap pr-3 py-4 text-sm text-gray-500">{person.isPnd}</td>

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                        }
                    

                    </div>
                </main>

            </React.Fragment>

        </Layout>




    </>);
}